module.exports = __webpack_public_path__ + "static/media/ceiling.ff3e9bc9.png";